/**
 * RevenueFlows v5.0 — Product Page JavaScript
 * Handles: Gallery, Variants, Cart, Sticky Header, FAQ, Scroll Reveal, Sticky Footer
 */
(function () {
  'use strict';

  /* ──────────────────────────────────────────────
     State
  ────────────────────────────────────────────── */
  var currentImageIndex = 0;
  var images = [];
  var variants = [];
  var selectedOptions = {};

  /* ──────────────────────────────────────────────
     Boot
  ────────────────────────────────────────────── */
  function init() {
    initGallery();
    initVariantSystem();
    initStickyHeader();
    initFaqAccordion();
    initScrollReveal();
    // initAjaxCart(); // DISABLED — was hijacking form submit, stripping selling_plan/bundle data, hardcoding /checkout redirect
    initStickyFooter();
    fixHeroButtonText();
    initReviewCarousel();
    initAlternatingBg();
    initQuickBuyModal();
    initBundleCards();
  }

  /* ══════════════════════════════════════════════
     KANIS BUNDLE CARDS — variant selector
  ══════════════════════════════════════════════ */
  function initBundleCards() {
    var cards = document.querySelectorAll('.bundle-card');
    if (cards.length === 0) return;
    var variantInput = document.getElementById('rf-variant-id');

    cards.forEach(function(card) {
      card.addEventListener('click', function(e) {
        cards.forEach(function(c){ c.classList.remove('active'); });
        card.classList.add('active');
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        var variantId = card.getAttribute('data-variant-id');
        if (variantId && variantInput) {
          variantInput.value = variantId;
        }

        // Update modal variant inputs
        document.querySelectorAll('.rf-modal-variant-id').forEach(function(inp){ inp.value = variantId; });

        // Update URL param
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          history.replaceState({}, '', url.toString());
        } catch(ex) {}

        // Trigger price display + add-to-cart state update
        // variants[] is the module-scoped array from initVariantSystem
        var variant = variants.filter(function(v){ return String(v.id) === String(variantId); })[0];
        if (variant) {
          applyVariant(variant);
        }
      });
    });
  }

  /**
   * Fix hero button text — Kaching Bundles overrides it to "Buy Now".
   * We watch for changes and force it back to "Add To Cart".
   */
  function fixHeroButtonText() {
    var btn = document.getElementById('rfAddToCart');
    if (!btn) return;
    // Capture the ORIGINAL innerHTML from the Liquid-rendered button (preserves emoji spans)
    var desiredHTML = btn.innerHTML;
    var desiredText = btn.textContent.trim();
    // Watch for Kaching changing it
    var observer = new MutationObserver(function() {
      if (btn.textContent.trim() !== desiredText) {
        btn.innerHTML = desiredHTML;
      }
    });
    observer.observe(btn, { childList: true, characterData: true, subtree: true });
  }

  /* ══════════════════════════════════════════════
     1. GALLERY / THUMBNAILS
  ══════════════════════════════════════════════ */
  function initGallery() {
    var dataEl = document.getElementById('rf-product-images');
    if (!dataEl) return;

    try {
      images = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('[RF] Could not parse product images JSON:', e);
      return;
    }

    if (!images.length) return;

    // Render thumbnails if a container exists
    renderThumbnails();

    // Set first image as active
    updateMainImage(0);

    // Preload all images for instant switching
    preloadImages();

    // Touch swipe on main image
    initTouchSwipe();

    // Amazon-style zoom on desktop
    initImageZoom();
  }

  /**
   * Render thumbnail buttons from image data.
   */
  function renderThumbnails() {
    // Bind clicks on existing thumbnails in HTML (.hero-thumbs img)
    var container = document.querySelector('.hero-thumbs');
    if (!container) return;

    var thumbImgs = container.querySelectorAll('img');
    if (thumbImgs.length) {
      thumbImgs.forEach(function (img, i) {
        img.addEventListener('click', function () {
          var idx = parseInt(this.getAttribute('data-image-index'), 10);
          if (!isNaN(idx)) {
            goToImage(idx);
          } else {
            // Fallback: use the data-full attribute
            var mainImg = document.getElementById('mainImage');
            if (mainImg && this.dataset.full) {
              mainImg.src = this.dataset.full;
            }
            // Toggle active
            thumbImgs.forEach(function (t) { t.classList.remove('active'); });
            this.classList.add('active');
          }
        });
      });
    }

    // Add gallery arrows — positioned relative to main image
    var mainImg = document.getElementById('mainImage');
    var gallery = document.querySelector('.hero-gallery');
    if (gallery && mainImg && !gallery.querySelector('.gallery-arrow') && images.length > 1) {
      var prevBtn = document.createElement('button');
      prevBtn.className = 'gallery-arrow prev';
      prevBtn.type = 'button';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.innerHTML = '&#10094;';
      prevBtn.onclick = function() { navigateGallery(-1); };

      var nextBtn = document.createElement('button');
      nextBtn.className = 'gallery-arrow next';
      nextBtn.type = 'button';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.innerHTML = '&#10095;';
      nextBtn.onclick = function() { navigateGallery(1); };

      gallery.appendChild(prevBtn);
      gallery.appendChild(nextBtn);

      // Position arrows at center of main image height
      function positionArrows() {
        var imgH = mainImg.offsetHeight;
        var arrowTop = (imgH / 2) + 'px';
        prevBtn.style.top = arrowTop;
        nextBtn.style.top = arrowTop;
        prevBtn.style.transform = 'translateY(-50%)';
        nextBtn.style.transform = 'translateY(-50%)';
      }
      positionArrows();
      mainImg.addEventListener('load', positionArrows);
      window.addEventListener('resize', positionArrows);
    }
  }

  /**
   * Update the main image and toggle active thumbnail.
   */
  function updateMainImage(index) {
    if (index < 0 || index >= images.length) return;
    currentImageIndex = index;

    var mainImg = document.getElementById('mainImage');
    if (mainImg && images[index]) {
      // Use the thumbnail's data-full attribute for instant switch (already cached by browser)
      var thumb = document.querySelectorAll('.hero-thumbs img')[index];
      if (thumb && thumb.dataset.full) {
        mainImg.src = thumb.dataset.full;
      } else {
        mainImg.src = images[index].src;
      }
      mainImg.alt = images[index].alt || 'Product image';
    }

    // Toggle active class on thumbnails
    var thumbs = document.querySelectorAll('.hero-thumbs img');
    thumbs.forEach(function (t, i) {
      t.classList.toggle('active', i === index);
    });
  }

  /**
   * Preload all gallery images for instant switching.
   */
  function preloadImages() {
    images.forEach(function (img) {
      var preload = new Image();
      preload.src = img.src;
    });
    // Also preload from data-full attributes
    document.querySelectorAll('.hero-thumbs img[data-full]').forEach(function (t) {
      var preload = new Image();
      preload.src = t.dataset.full;
    });
  }

  /**
   * Navigate gallery by direction: 1 (next) or -1 (prev).
   */
  function navigateGallery(direction) {
    if (!images.length) return;
    var next = (currentImageIndex + direction + images.length) % images.length;
    updateMainImage(next);
  }

  /**
   * Jump to a specific image index.
   */
  function goToImage(index) {
    if (index >= 0 && index < images.length) {
      updateMainImage(index);
    }
  }

  /**
   * Touch swipe support on the main image container.
   */
  function initTouchSwipe() {
    var mainImg = document.getElementById('mainImage');
    if (!mainImg) return;

    var startX = 0;
    var SWIPE_THRESHOLD = 50;

    mainImg.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });

    mainImg.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) < SWIPE_THRESHOLD) return;
      // Swipe left = next, swipe right = prev
      navigateGallery(diff < 0 ? 1 : -1);
    }, { passive: true });
  }

  /**
   * Amazon-style zoom: hovering over the main image shows a zoomed panel to the right.
   * On mobile, enables Instagram-style swipe.
   */
  function initImageZoom() {
    var mainImg = document.getElementById('mainImage');
    if (!mainImg) return;
    if (window.innerWidth < 901) return;

    var hero = mainImg.closest('.hero');
    if (!hero) return;
    var heroInfo = hero.querySelector('.hero-info');
    if (!heroInfo) return;

    // Create zoom panel over hero-info
    var zoomPanel = document.createElement('div');
    zoomPanel.className = 'rf-zoom-panel';
    heroInfo.style.position = 'relative';
    heroInfo.appendChild(zoomPanel);

    // Create zoom image inside panel
    var zoomImg = document.createElement('img');
    zoomImg.className = 'rf-zoom-img';
    zoomPanel.appendChild(zoomImg);

    // Create lens on main image
    var gallery = mainImg.closest('.hero-gallery');
    gallery.style.position = 'relative';
    var lens = document.createElement('div');
    lens.className = 'rf-zoom-lens';
    gallery.appendChild(lens);

    mainImg.addEventListener('mouseenter', function() {
      var src = mainImg.src;
      // Get highest resolution
      src = src.replace(/width=\d+/, 'width=2000');
      zoomImg.src = src;
      zoomPanel.style.display = 'block';
      lens.style.display = 'block';
      mainImg.style.cursor = 'crosshair';
    });

    mainImg.addEventListener('mouseleave', function() {
      zoomPanel.style.display = 'none';
      lens.style.display = 'none';
      mainImg.style.cursor = 'zoom-in';
    });

    mainImg.addEventListener('mousemove', function(e) {
      var rect = mainImg.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      x = Math.max(0, Math.min(1, x));
      y = Math.max(0, Math.min(1, y));

      // Position lens
      lens.style.left = (e.clientX - rect.left - 50) + 'px';
      lens.style.top = (e.clientY - rect.top - 50) + 'px';

      // Zoom: scale image 2.5x and translate based on mouse position
      var scale = 2.5;
      var tx = -(x * (scale - 1) * 100 / scale);
      var ty = -(y * (scale - 1) * 100 / scale);
      zoomImg.style.transform = 'scale(' + scale + ')';
      zoomImg.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
    });
  }

  /* ══════════════════════════════════════════════
     2. VARIANT PICKER
  ══════════════════════════════════════════════ */
  function initVariantSystem() {
    var dataEl = document.getElementById('rf-product-variants');
    if (!dataEl) return;

    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('[RF] Could not parse product variants JSON:', e);
      return;
    }

    // Pre-select the first available variant
    if (variants.length) {
      var first = variants[0];
      if (first.option1) selectedOptions['option1'] = first.option1;
      if (first.option2) selectedOptions['option2'] = first.option2;
      if (first.option3) selectedOptions['option3'] = first.option3;
      applyVariant(first);
    }

    // Bind variant button clicks
    var btns = document.querySelectorAll('.size-btn, .rf-size-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionName = this.getAttribute('data-option-name');
        var optionValue = this.getAttribute('data-option-value');
        if (optionName && optionValue) {
          handleOptionChange(this, optionValue, optionName);
        }
      });
    });
  }

  /**
   * Handle a variant option change.
   * Updates selected options, finds the matching variant, and applies it.
   */
  function handleOptionChange(el, value, optionName) {
    // Map option name to option1/option2/option3
    var optionGroups = document.querySelectorAll('.option-group, .rf-option-group');
    var optionIndex = 0;
    optionGroups.forEach(function (g, i) {
      var label = g.querySelector('.option-label, .rf-option-label');
      if (label && label.textContent.replace(':', '').trim() === optionName) {
        optionIndex = i;
      }
    });
    var optionKey = 'option' + (optionIndex + 1);
    selectedOptions[optionKey] = value;

    // Toggle active state on sibling buttons
    var group = el.closest('.option-group') || el.closest('.rf-option-group') || el.parentElement;
    if (group) {
      group.querySelectorAll('.size-btn, .rf-size-btn').forEach(function (btn) {
        btn.classList.toggle('active', btn.getAttribute('data-option-value') === value);
      });
    }

    // Find matching variant
    var match = findMatchingVariant();
    if (match) {
      applyVariant(match);
    }
  }

  /**
   * Find a variant that matches all currently selected options.
   */
  function findMatchingVariant() {
    return variants.find(function (v) {
      var match = true;
      if (selectedOptions.option1 && v.option1 !== selectedOptions.option1) match = false;
      if (selectedOptions.option2 && v.option2 !== selectedOptions.option2) match = false;
      if (selectedOptions.option3 && v.option3 !== selectedOptions.option3) match = false;
      return match;
    }) || null;
  }

  /**
   * Apply a variant: update hidden input, price, URL, and gallery image.
   */
  function applyVariant(variant) {
    // Update hidden variant ID
    var hiddenInput = document.getElementById('rf-variant-id');
    if (hiddenInput) {
      hiddenInput.value = variant.id;
    }

    // Update price display
    updatePriceDisplay(variant);

    // Update URL without reload
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    }

    // If variant has a featured image, update gallery
    if (variant.featured_image && variant.featured_image.src) {
      // Extract filename for matching (Shopify adds sizing params that differ)
      var variantFile = variant.featured_image.src.split('?')[0].split('/').pop();
      var matchIdx = images.findIndex(function (img) {
        return img.src.includes(variantFile);
      });
      if (matchIdx !== -1) {
        updateMainImage(matchIdx);
      }
    }

    // Update add-to-cart button availability
    var addBtn = document.getElementById('rfAddToCart');
    if (addBtn) {
      if (variant.available === false) {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = '\uD83D\uDC49 Add To Cart';
      }
    }
  }

  /**
   * Detect if Shopify Markets is presenting in a non-base currency.
   * When true, the server has already rendered the correct converted price (e.g. ₹3,800);
   * our JS would only overwrite it with the WRONG base-currency value ($3,800), so skip.
   * Two signals checked: explicit base-currency mismatch (most reliable) and rate != 1 (fallback).
   */
  function isMarketsConverted() {
    if (typeof window.Shopify === 'undefined' || !Shopify.currency) return false;
    /* Method 1: Liquid told us the shop's base currency, compare to active */
    if (window.__rfShopBaseCurrency && Shopify.currency.active) {
      if (String(Shopify.currency.active).toUpperCase() !== String(window.__rfShopBaseCurrency).toUpperCase()) {
        return true;
      }
    }
    /* Method 2: exchange rate != 1 means conversion is happening */
    var rate = parseFloat(Shopify.currency.rate);
    if (rate && rate !== 1) return true;
    return false;
  }

  /**
   * Update the price display element with variant pricing.
   * Preserves the full pricing structure: sale label, price-row, save badge, price-per.
   */
  function updatePriceDisplay(variant) {
    var container = document.getElementById('rfPriceDisplay');
    if (!container) return;

    /* MARKETS GUARD: if presentment currency != shop base, keep the server-rendered
       price. Otherwise we'd flicker ₹3,800 → $3,800 on every variant change / page load. */
    if (isMarketsConverted()) return;

    var price = formatMoney(variant.price);
    var comparePrice = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
    var hasCompare = comparePrice && variant.compare_at_price > variant.price;

    // Preserve shipping pill and trust line
    var shipPill = container.querySelector('.price-ship-pill');
    var shipHTML = shipPill ? shipPill.outerHTML : '<span class="price-ship-pill">Fast Shipping</span>';
    var trustLine = container.querySelector('.price-trust-line');
    var trustHTML = trustLine ? trustLine.outerHTML : '';

    var html = '';

    if (hasCompare) {
      html += '<div class="sale-label">Sale</div>';
    }

    html += '<div class="price-row">';
    html += '<span class="price-current">' + price + '</span>';

    if (hasCompare) {
      html += '<span class="price-was">' + comparePrice + '</span>';
      var savingsPct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      html += '<span class="price-badge">Save ' + savingsPct + '%</span>';
    }

    html += shipHTML;
    html += '</div>';
    if (trustHTML) html += trustHTML;

    container.innerHTML = html;
  }

  /**
   * Format cents into dollars (Shopify prices are in cents).
   */
  function formatMoney(cents) {
    /* 1. Prefer Shopify's built-in formatter (handles Markets currency conversion) */
    if (typeof window.Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents); } catch(e) { /* fall through */ }
    }
    /* 2. Use shop money format passed from Liquid (window.__rfShopMoneyFormat) */
    if (window.__rfShopMoneyFormat) {
      var amount = (cents / 100).toFixed(2);
      return window.__rfShopMoneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    /* 3. Last-resort fallback: hardcoded USD */
    return '$' + (cents / 100).toFixed(2);
  }

  /* ══════════════════════════════════════════════
     3. QUANTITY CONTROLS
  ══════════════════════════════════════════════ */

  /**
   * Increment or decrement the quantity input.
   * @param {number} delta — typically +1 or -1
   */
  function updateQty(delta) {
    var input = document.getElementById('rfQty');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var next = Math.min(10, Math.max(1, current + delta));
    input.value = next;

    // Sync sticky footer qty if present
    var footerQty = document.querySelector('#stickyFooter .rf-sticky-qty-value');
    if (footerQty) {
      footerQty.textContent = next;
    }
  }

  /* ══════════════════════════════════════════════
     4. AJAX CART
  ══════════════════════════════════════════════ */
  function initAjaxCart() {
    var addBtn = document.getElementById('rfAddToCart');
    if (!addBtn) return;

    var form = addBtn.closest('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCartAndCheckout();
    });
  }

  /**
   * POST item to cart via AJAX, then redirect to checkout.
   */
  function addToCartAndCheckout() {
    var variantInput = document.getElementById('rf-variant-id');
    var qtyInput = document.getElementById('rfQty');

    var variantId = variantInput ? variantInput.value : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    if (!variantId) {
      console.warn('[RF] No variant selected');
      return;
    }

    var addBtn = document.getElementById('rfAddToCart');
    var originalText = addBtn ? addBtn.textContent : '';
    if (addBtn) {
      addBtn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: qty
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function () {
        if (addBtn) { addBtn.disabled = false; }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[RF] Add to cart failed:', err);
        if (addBtn) {
          addBtn.disabled = false;
        }
        // Fallback: direct cart URL
        setTimeout(function () {
          window.location.href = '/cart/' + variantId + ':' + qty;
        }, 2000);
      });
  }

  /* ══════════════════════════════════════════════
     5. STICKY HEADER
  ══════════════════════════════════════════════ */
  function initStickyHeader() {
    var buySection = document.getElementById('buy-now');
    var nav = document.getElementById('rfNav');
    if (!buySection || !nav) return;

    // Remove any leftover spacers from previous versions
    document.querySelectorAll('.rf-nav-spacer').forEach(function(s) { s.remove(); });

    // Force theme header to be non-sticky (sandwiched mode)
    // This prevents the theme header from peeking through on scroll
    var themeHeader = document.querySelector('#shopify-section-header');
    if (themeHeader) {
      themeHeader.style.position = 'relative';
      // Also check for sticky wrappers inside the header
      var headerInner = themeHeader.querySelector('.header-wrapper, .header, .sticky-header, [class*="header"]');
      if (headerInner) headerInner.style.position = 'relative';
    }

    // Nav is already position:sticky via CSS — no spacer needed
    // Just toggle is-sticky class for visual state changes
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          nav.classList.add('is-sticky');
        } else {
          nav.classList.remove('is-sticky');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    observer.observe(buySection);
  }

  /* ══════════════════════════════════════════════
     6. FAQ ACCORDION
  ══════════════════════════════════════════════ */
  function initFaqAccordion() {
    var triggers = document.querySelectorAll('.faq-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var parentItem = this.closest('.faq-item');
        if (!parentItem) return;

        var isActive = parentItem.classList.contains('active');

        // Close all other FAQ items
        document.querySelectorAll('.faq-item.active').forEach(function (item) {
          item.classList.remove('active');
        });

        // Toggle the clicked item (open if it was closed)
        if (!isActive) {
          parentItem.classList.add('active');
        }
      });
    });

    // First item is already open via HTML (.active class), so no JS needed for default
  }

  /* ══════════════════════════════════════════════
     7. SCROLL REVEAL
  ══════════════════════════════════════════════ */
  function initScrollReveal() {
    var revealEls = document.querySelectorAll('[data-reveal]');
    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: reveal everything immediately
      revealEls.forEach(function (el) {
        el.classList.add('revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ══════════════════════════════════════════════
     8. STICKY FOOTER
  ══════════════════════════════════════════════ */
  function initStickyFooter() {
    var heroInfo = document.querySelector('.rf-hero-info');
    var stickyFooter = document.getElementById('stickyFooter');
    if (!heroInfo || !stickyFooter) return;

    // Show/hide footer based on product info visibility
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyFooter.classList.add('visible');
        } else {
          stickyFooter.classList.remove('visible');
        }
      });
    }, {
      threshold: 0
    });

    observer.observe(heroInfo);

    // Sticky footer quantity buttons
    var footerQtyBtns = stickyFooter.querySelectorAll('[data-action]');
    footerQtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = this.getAttribute('data-action');
        if (action === 'increase') {
          updateQty(1);
        } else if (action === 'decrease') {
          updateQty(-1);
        }
      });
    });

    // Sticky footer buy button — scroll to hero buy box (let user click native Add to Cart)
    var stickyBuyBtn = document.getElementById('stickyBuyBtn');
    if (stickyBuyBtn) {
      stickyBuyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('rfPricingArea') ||
                     document.querySelector('.hero-info') ||
                     document.getElementById('buy-now');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* ══════════════════════════════════════════════
     9. HERO REVIEW CAROUSEL (Template 2)
  ══════════════════════════════════════════════ */
  function initReviewCarousel() {
    var carousel = document.querySelector('.review-carousel');
    if (!carousel) return;

    var cards = carousel.querySelectorAll('.review-card');
    if (cards.length === 0) return;

    var dots = carousel.querySelectorAll('.review-dot');
    var prevBtn = carousel.querySelector('.review-arrow-prev');
    var nextBtn = carousel.querySelector('.review-arrow-next');
    var current = 0;
    var timer = null;
    var INTERVAL = 4000;

    function showCard(index) {
      cards.forEach(function (c) { c.classList.remove('active'); });
      dots.forEach(function (d) { d.classList.remove('active'); });
      current = (index + cards.length) % cards.length;
      cards[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    function startTimer() {
      stopTimer();
      timer = setInterval(function () { showCard(current + 1); }, INTERVAL);
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { showCard(current - 1); startTimer(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { showCard(current + 1); startTimer(); });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { showCard(i); startTimer(); });
    });

    carousel.addEventListener('mouseenter', stopTimer);
    carousel.addEventListener('mouseleave', startTimer);

    showCard(0);
    startTimer();
  }

  /* ══════════════════════════════════════════════
     10. QUICK BUY POPUP MODAL
  ══════════════════════════════════════════════ */
  function initQuickBuyModal() {
    var overlay = document.getElementById('rfQuickBuyOverlay');
    if (!overlay) return;

    // ── STORE-SPECIFIC BEHAVIOR ──
    var hostname = window.location.hostname.toLowerCase();
    var isPrimalAlchemy = /primalalchemy|4i50gy/.test(hostname);
    var isGrabit = /grabit/.test(hostname);
    var isRainmakersDojo = /directresponsesumo|thegmcrvid/.test(hostname);

    // Stores that use smooth-scroll instead of popup (need bundles/subscriptions to work natively)
    // GrabIt: testing popup mode so Kaching bundles load in popup
    var skipPopupForThisStore = isPrimalAlchemy;

    if (skipPopupForThisStore) {
      // 1. Aggressively unhide Kaching/Appstle widgets wherever they are in the DOM
      var unhideCSS = document.createElement('style');
      unhideCSS.textContent =
        'kaching-bundles-block,' +
        '.kaching-bundles,' +
        '.rf-scope kaching-bundles-block,' +
        '.rf-scope .kaching-bundles,' +
        '.rf-scope .hero-info .kaching-bundles,' +
        '.appstle_sub_widget,' +
        '[id^="appstle_subscription_widget"],' +
        '.rf-scope .appstle_sub_widget,' +
        '.rf-scope [id^="appstle_subscription_widget"]{' +
          'display:block!important;' +
          'visibility:visible!important;' +
          'opacity:1!important;' +
          'height:auto!important;' +
          'max-height:none!important;' +
          'overflow:visible!important' +
        '}';
      document.head.appendChild(unhideCSS);

      // 2. All section CTA buttons → smooth scroll to buy box (no popup)
      document.querySelectorAll('.cta-btn, .rf-pnav-cta').forEach(function(btn) {
        // Skip the main hero Add to Cart and modal buttons
        if (btn.closest('.rf-modal') || btn.closest('.hero-info')) return;
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var target = document.getElementById('rfPricingArea') ||
                       document.querySelector('.hero-info') ||
                       document.getElementById('buy-now');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      return; // Skip popup setup entirely for these stores
    }

    // ── RAINMAKERS DOJO (and default): POPUP MODE with /checkout→/cart redirect ──
    // Aggressive checkout→cart rewriting: monkey-patch all nav methods
    try {
      // Method 1: location.assign override
      var origAssign = window.location.assign;
      window.location.assign = function(url) {
        if (typeof url === 'string' && /\/checkouts?(\/|$|\?|#)/.test(url)) {
          return origAssign.call(window.location, '/cart');
        }
        return origAssign.call(window.location, url);
      };
      // Method 2: location.replace override
      var origReplace = window.location.replace;
      window.location.replace = function(url) {
        if (typeof url === 'string' && /\/checkouts?(\/|$|\?|#)/.test(url)) {
          return origReplace.call(window.location, '/cart');
        }
        return origReplace.call(window.location, url);
      };
      // Method 3: location.href setter override (covers window.location = 'url' and window.location.href = 'url')
      var hrefDesc = Object.getOwnPropertyDescriptor(window.Location.prototype, 'href') ||
                     Object.getOwnPropertyDescriptor(window.location, 'href');
      if (hrefDesc && hrefDesc.set) {
        var origHrefSet = hrefDesc.set;
        Object.defineProperty(window.location, 'href', {
          configurable: true,
          get: function() { return hrefDesc.get.call(window.location); },
          set: function(val) {
            if (typeof val === 'string' && /\/checkouts?(\/|$|\?|#)/.test(val)) {
              val = '/cart';
            }
            origHrefSet.call(window.location, val);
          }
        });
      }
    } catch(e) {}

    // Method 4: watch for URL changes via setInterval after form submit, redirect if we ended up on /checkout
    try {
      var origFetch = window.fetch;
      window.fetch = function(url, opts) {
        var result = origFetch.apply(this, arguments);
        if (typeof url === 'string' && (/\/cart\/add/.test(url) || /kaching/.test(url))) {
          result.then(function() {
            var checks = 0;
            var poller = setInterval(function() {
              checks++;
              if (checks > 50 || /\/cart\b/.test(window.location.pathname)) {
                clearInterval(poller);
                return;
              }
              if (/\/checkouts?/.test(window.location.pathname)) {
                clearInterval(poller);
                window.location.replace('/cart');
              }
            }, 100);
          }).catch(function(){});
        }
        return result;
      };
    } catch(e) {}

    var closeBtn = document.getElementById('rfModalClose');
    var bundleSlot = document.getElementById('rfModalBundleSlot');
    var bundlesContainer = document.getElementById('rfModalBundles');

    // Store original parent info when we first move the widget
    var kachingOriginalParent = null;
    var kachingNextSibling = null;
    var appstleOriginalParent = null;
    var appstleNextSibling = null;

    // Open modal
    function openModal() {
      // Find Kaching widget NOW (it loads late via its own JS)
      var kachingWidget = document.querySelector('.kaching-bundles');

      // Find Appstle subscription widget too (same pattern as Kaching)
      var appstleWidget = document.querySelector('.appstle_sub_widget, [id^="appstle_subscription_widget"]');

      if (kachingWidget && bundleSlot) {
        if (!kachingOriginalParent) {
          kachingOriginalParent = kachingWidget.parentElement;
          kachingNextSibling = kachingWidget.nextSibling;
        }
        bundleSlot.appendChild(kachingWidget);
        bundlesContainer.style.display = '';
      } else if (!appstleWidget && bundlesContainer) {
        bundlesContainer.style.display = 'none';
      }

      // Move Appstle subscription widget into popup (alongside Kaching if both exist)
      if (appstleWidget && bundleSlot) {
        if (!appstleOriginalParent) {
          appstleOriginalParent = appstleWidget.parentElement;
          appstleNextSibling = appstleWidget.nextSibling;
        }
        bundleSlot.appendChild(appstleWidget);
        bundlesContainer.style.display = '';
      }

      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';

      // Sync variant ID
      var mainVariantInput = document.getElementById('rf-variant-id');
      overlay.querySelectorAll('.rf-modal-variant-id').forEach(function(inp) {
        if (mainVariantInput) inp.value = mainVariantInput.value;
      });

      // Sync image
      var mainImg = document.getElementById('mainImage');
      var modalImg = document.getElementById('rfModalImg');
      if (mainImg && modalImg) modalImg.src = mainImg.src;

      // Sync price
      var priceDisplay = document.getElementById('rfPriceDisplay');
      var modalPrice = document.getElementById('rfModalPrice');
      if (priceDisplay && modalPrice) {
        var cp = priceDisplay.querySelector('.price-current');
        var wp = priceDisplay.querySelector('.price-was');
        if (cp) {
          var h = '<span class="rf-modal-price">' + cp.textContent + '</span>';
          if (wp) h += '<span class="rf-modal-compare">' + wp.textContent + '</span>';
          modalPrice.innerHTML = h;
        }
      }
    }

    // Close modal — move Kaching + Appstle widgets BACK to original positions
    function closeModal() {
      var kachingWidget = document.querySelector('.kaching-bundles');
      if (kachingWidget && kachingOriginalParent) {
        if (kachingNextSibling && kachingNextSibling.parentElement === kachingOriginalParent) {
          kachingOriginalParent.insertBefore(kachingWidget, kachingNextSibling);
        } else {
          kachingOriginalParent.appendChild(kachingWidget);
        }
      }
      var appstleWidget = document.querySelector('.appstle_sub_widget, [id^="appstle_subscription_widget"]');
      if (appstleWidget && appstleOriginalParent) {
        if (appstleNextSibling && appstleNextSibling.parentElement === appstleOriginalParent) {
          appstleOriginalParent.insertBefore(appstleWidget, appstleNextSibling);
        } else {
          appstleOriginalParent.appendChild(appstleWidget);
        }
      }
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Attach to ALL CTA buttons — everything opens the popup
    // EXCEPTION: when template has rf-hero-native-submit, skip the hero Add to Cart button
    // (the #rfAddToCart button submits the form natively so Kaching/Appstle fire as usual)
    var heroNativeSubmit = document.querySelector('.rf-scope.rf-hero-native-submit') !== null;
    document.querySelectorAll('.cta-btn, .rf-pnav-cta').forEach(function(btn) {
      // Skip buttons inside the modal itself
      if (btn.closest('.rf-modal')) return;
      // Skip the hero form Add to Cart button when native submit mode is on
      if (heroNativeSubmit && btn.id === 'rfAddToCart') return;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });

    // Hero form — DON'T intercept submit. Kaching's submit listener is attached to this form
    // and must fire to add the selected bundle to cart.
    var heroForm = document.querySelector('.hero-info form');

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

    // Variant clicks in modal
    overlay.querySelectorAll('.size-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var mainBtns = document.querySelectorAll('#rfVariantPicker .size-btn[data-option-value="' + this.dataset.optionValue + '"]');
        mainBtns.forEach(function(mb) { mb.click(); });
        this.closest('.option-values').querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        setTimeout(function() {
          var mv = document.getElementById('rf-variant-id');
          overlay.querySelectorAll('.rf-modal-variant-id').forEach(function(inp) { if (mv) inp.value = mv.value; });
        }, 100);
      });
    });

    // INTERCEPT modal form submit — trigger the HERO form's submit so Kaching/Appstle hooks fire.
    // Before submit: sync any selling_plan selection from Appstle (in popup) into the hero form.
    // Also ensure cart redirects to /cart page (not checkout).
    var modalForm = overlay.querySelector('.rf-modal form');
    if (modalForm) {
      modalForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var heroFormEl = document.querySelector('.hero-info form');
        if (!heroFormEl) { modalForm.submit(); return; }

        // --- SYNC SELLING_PLAN (Appstle subscription) into hero form ---
        // Try multiple methods to find the currently-selected selling plan ID:
        var planId = null;

        // Method 1: any input[name="selling_plan"] with value on the page
        var spInput = document.querySelector('input[name="selling_plan"][value]:not([value=""])');
        if (spInput) planId = spInput.value;

        // Method 2: Appstle selected option has data attribute
        if (!planId) {
          var selected = document.querySelector('.appstle_subscription_wrapper_option.appstle_selected_background, .appstle_subscription_wrapper_option.appstle-active-o');
          if (selected) {
            planId = selected.getAttribute('data-selling-plan-id') ||
                     selected.getAttribute('data-plan-id') ||
                     selected.getAttribute('data-sellingplanid') ||
                     (selected.querySelector('input[type="radio"]:checked, input[type="radio"][value]') && selected.querySelector('input[type="radio"]:checked, input[type="radio"][value]').value);
          }
        }

        // Method 3: Shopify selling_plans_selector
        if (!planId) {
          var spSelector = document.querySelector('[name^="selling_plan_"]:checked, [name="selling_plan"]:checked');
          if (spSelector) planId = spSelector.value;
        }

        // Inject selling_plan into hero form (or update existing)
        var existingSP = heroFormEl.querySelector('input[name="selling_plan"]');
        if (planId && /^\d+$/.test(planId)) {
          if (existingSP) {
            existingSP.value = planId;
          } else {
            var hid = document.createElement('input');
            hid.type = 'hidden'; hid.name = 'selling_plan'; hid.value = planId;
            heroFormEl.appendChild(hid);
          }
        } else if (existingSP) {
          // No subscription selected — remove any stale selling_plan
          existingSP.remove();
        }

        // --- REDIRECT to /cart (not /checkout) ---
        var existingRT = heroFormEl.querySelector('input[name="return_to"]');
        if (!existingRT) {
          var rt = document.createElement('input');
          rt.type = 'hidden'; rt.name = 'return_to'; rt.value = '/cart';
          heroFormEl.appendChild(rt);
        } else {
          existingRT.value = '/cart';
        }

        // Fire hero form submit — Kaching/Appstle submit hooks fire, form submits with all data
        if (heroFormEl.requestSubmit) {
          heroFormEl.requestSubmit();
        } else {
          heroFormEl.submit();
        }

        // Close THIS popup after firing add-to-cart (2026-06-04).
        // With a slide-cart app (Kaching Cart) the add is AJAX — no page reload — so the
        // quick-buy modal would otherwise stay open BEHIND the cart slider. Close it so
        // the slider is the only thing on screen. Slight delay lets the app's submit
        // listener capture the form first. Harmless if the form does a full redirect.
        setTimeout(function () { closeModal(); }, 60);
      });
    }
  }

  /* ══════════════════════════════════════════════
     11. ALTERNATING SECTION BACKGROUNDS
  ══════════════════════════════════════════════ */
  function initAlternatingBg() {
    var wrap = document.querySelector('.rf-sections-wrap');
    if (!wrap) return;
    // If dark rhythm is on, let CSS handle it — don't overlay JS-driven backgrounds
    if (wrap.classList.contains('rf-dark-rhythm')) return;
    var sections = wrap.querySelectorAll(':scope > section');
    var cream = 'var(--cream, #F7F3EE)';
    var white = 'var(--white, #FFFFFF)';
    /* Track last color set so we ALWAYS pick the opposite for the next section.
       Start as if previous was 'white' so the first section gets cream. */
    var lastColor = white;
    /* Helper: setProperty with !important so any CSS rule can't override us */
    function paint(el, color, debugLabel) {
      el.style.setProperty('background', color, 'important');
      /* DEBUG: also stamp a data-attribute so we can inspect in DevTools */
      el.setAttribute('data-rf-bg', color === cream ? 'cream' : 'white');
      el.setAttribute('data-rf-bg-idx', debugLabel);
    }
    /* Helper: is this section actually visible? Hidden sections shouldn't
       count in alternation — otherwise an invisible cream section between
       two visible ones makes them visually adjacent with same color. */
    function isVisible(el) {
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      /* Also catch zero-height collapsed sections */
      if (el.offsetHeight === 0 && el.offsetWidth === 0) return false;
      return true;
    }
    /* First, find the LAST visible non-guarantee section BEFORE guarantee.
       That's the one we may need to flip if a cream-cream collision would occur. */
    var visibleSections = [];
    sections.forEach(function(s, i) {
      if (isVisible(s)) visibleSections.push({ el: s, originalIdx: i });
      else { s.setAttribute('data-rf-bg', 'hidden-skip'); s.setAttribute('data-rf-bg-idx', i + ''); }
    });
    visibleSections.forEach(function(item, vi) {
      var s = item.el;
      var i = item.originalIdx;
      if (s.classList.contains('guarantee')) {
        if (lastColor === cream && vi > 0) {
          var prev = visibleSections[vi - 1].el;
          if (prev && !prev.classList.contains('guarantee')) {
            paint(prev, white, visibleSections[vi - 1].originalIdx + '-flipped');
          }
        }
        lastColor = cream;
        s.setAttribute('data-rf-bg', 'cream-forced');
        s.setAttribute('data-rf-bg-idx', i + '');
        return;
      }
      var thisColor = (lastColor === cream) ? white : cream;
      paint(s, thisColor, i + '');
      lastColor = thisColor;
    });
  }

  /* ══════════════════════════════════════════════
     GLOBAL FUNCTIONS
     Exposed on window for inline onclick handlers in HTML
  ══════════════════════════════════════════════ */
  window.navigateGallery = function (direction) {
    navigateGallery(direction);
  };

  window.goToImage = function (index) {
    goToImage(index);
  };

  window.handleOptionChange = function (el, value, optionName) {
    handleOptionChange(el, value, optionName);
  };

  window.updateQty = function (delta) {
    updateQty(delta);
  };

  /* ──────────────────────────────────────────────
     Initialize when DOM is ready
  ────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
